



























































































































































































































import Vue from 'vue'
import Nav from '@/components/Nav.vue'
import ImageUpload from '@/components/ImageUpload.vue'
import { ApiResponse, UserData } from '@/interfaces'
import { mapState } from 'vuex'

export default Vue.extend({
  components: { Nav, ImageUpload },
  data() {
    return {
      busy: false,
      isDisabled: false,
      userData: {
        email: null,
        firstName: null,
        lastName: null,
        mobile: null,
        avatar: null,
        tmsLogin: null,
        tmsRefreshToken: null,
        tmsRefreshTokenValidity: null,
        twoFactorCode: null,
        twoFactorValidUntil: null,
        autobizAccessToken: null,
        autobizTokenExpiresOn: null,
        licenceExpirationDate: null,
        chargeLimit: null,
        loginLockedUntil: null,
        oldUserId: null,
        last_ip: null,
      } as UserData,
      viewportWidth: 0,
      autocompleteNone: 'none',
      changeDetected: null as null | boolean,
      oldUser: null as null | number,
      selectedRoles: [] as string[],
      restrictionRoles: ['RESTRICTION_IBAN', 'RESTRICTION_COMPTA', 'RESTRICTION_USER', 'RESTRICTION_EXPORT_CONTACTS', 'RESTRICTION_CONFIGURATION'],
      rules: {
        mobile: [
          {
            validator: (_rule: unknown, value: string, callback: (error?: Error) => void) => {
              if (!value) {
                callback()
                return
              }
              const isValid = /^(\+\d{1,3}\s?)?(\d\s?)*\d$/.test(value)
              if (!isValid) {
                callback(new Error('Format invalide. Ex: +33 612345678 ou 0612345678'))
                return
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['user', 'connectedAs']),
    routeUserId(): number | null {
      const rawId = this.$route.params.id
      if (!rawId) {
        return null
      }
      const parsed = Number(rawId)
      return Number.isNaN(parsed) ? null : parsed
    },
    tmsTokenExpirationLabel(): string {
      if (!this.userData.tmsRefreshTokenValidity) {
        return ''
      }
      const date = new Date(this.userData.tmsRefreshTokenValidity)
      if (isNaN(date.getTime())) {
        return ''
      }
      const formatted = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(date)
      return ` - expiration : ${formatted}`
    },
    twoFactorExpirationLabel(): string {
      if (!this.userData.twoFactorValidUntil) {
        return ''
      }
      const date = new Date(this.userData.twoFactorValidUntil)
      if (isNaN(date.getTime())) {
        return ''
      }
      const formatted = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(date)
      return ` - expiration : ${formatted}`
    },
    autobizTokenExpirationLabel(): string {
      if (!this.userData.autobizTokenExpiresOn) {
        return ''
      }
      const date = new Date(this.userData.autobizTokenExpiresOn)
      if (isNaN(date.getTime())) {
        return ''
      }
      const formatted = new Intl.DateTimeFormat('fr-FR', { dateStyle: 'short', timeStyle: 'short' }).format(date)
      return ` - expiration : ${formatted}`
    },
    availableRoles(): string[] {
      return Array.from(new Set([...this.restrictionRoles, ...this.selectedRoles]))
    },
    userId(): number {
      return this.routeUserId ?? this.userData.oldUserId ?? this.user?.id ?? 0
    },
    avatarUrl(): string {
      if (this.userId && this.userData.avatar) {
        return `${process.env.VUE_APP_API_URL}/user/${this.userId}/avatar`
      }
      return ''
    },
    isExeveAdmin(): boolean {
      return this.user !== null && (!!this.user.isAdmin || this.connectedAs !== null)
    },
  },
  watch: {
    user(newVal) {
      if (this.routeUserId || !newVal?.id) {
        return
      }
      this.fetchUserById(newVal.id)
    },
    routeUserId: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchUserById(newVal)
        }
      },
    },
    userData: {
      deep: true,
      immediate: true,
      handler() {
        if (this.changeDetected === false) {
          this.changeDetected = true
        }
      },
    },
    selectedRoles() {
      if (this.changeDetected === false) {
        this.changeDetected = true
      }
    },
  },
  mounted() {
    this.viewportWidth = window.innerWidth
    if (!this.routeUserId && this.user?.id) {
      this.fetchUserById(this.user.id)
    }
    this.$nextTick(() => {
      this.changeDetected = false
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    setAttribute() {
      this.autocompleteNone = 'none'
    },
    onResize() {
      this.viewportWidth = window.innerWidth
    },
    cancelForm() {
      this.$router.back()
    },
    setUserData(data: UserData) {
      this.userData = {
        ...data,
        roles: Array.isArray(data.roles) ? data.roles : data.roles ?? null,
      }
      if (Array.isArray(data.roles)) {
        this.selectedRoles = data.roles
      } else {
        this.selectedRoles = []
      }
    },
    fetchUserById(userId: number) {
      this.busy = true
      this.$api
        .get(`/user/${userId}`)
        .then((response) => {
          const apiResponse = response.data as ApiResponse
          this.setUserData(apiResponse.data)
          this.userData.oldUserId = userId
        })
        .catch(() => {
          this.$notify({
            type: 'error',
            title: 'Erreur',
            message: 'Impossible de charger les informations utilisateur.',
          })
        })
        .finally(() => {
          this.busy = false
          this.$nextTick(() => {
            this.changeDetected = false
          })
        })
    },
    formatDate(str: string): string {
      const date = Date.parse(str)
      if (!isNaN(date)) {
        return new Intl.DateTimeFormat('fr-FR', { dateStyle: 'medium', timeStyle: 'short' }).format(date)
      } else {
        return '-'
      }
    },
    goBack() {
      this.$router.back()
    },
    submit() {
      const form = this.$refs.userForm as { validate?: (cb: (valid: boolean) => void) => void } | undefined
      if (form?.validate) {
        form.validate((valid: boolean) => {
          if (!valid) {
            return
          }
          this.busy = true
          const loading = this.$loading({
            target: '.form-panel',
            text: 'Chargement des données...',
          })
          const userIdToEdit = this.routeUserId ?? this.userData.oldUserId ?? this.user.id
          const payload: Record<string, unknown> = { ...this.userData, roles: this.selectedRoles }
          this.$api
            .put(`/user/${userIdToEdit}`, payload)
            .then((response) => {
              const apiResponse = response.data

              this.setUserData(apiResponse.data)
              this.$notify({
                type: 'success',
                title: 'Succès',
                message: 'Utilisateur modifié avec succès !',
              })
            })
            .catch((error) => {
              if (error.response) {
                const apiResponse = error.response.data as ApiResponse

                this.$notify({
                  type: 'error',
                  title: 'Erreur',
                  message:
                    apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
                })
              }
            })
            .finally(() => {
              this.busy = false
              this.changeDetected = false
              loading.close()
            })
        })
        return
      }

      this.busy = true
      const loading = this.$loading({
        target: '.form-panel',
        text: 'Chargement des données...',
      })
      const userIdToEdit = this.routeUserId ?? this.userData.oldUserId ?? this.user.id
      const payload: Record<string, unknown> = { ...this.userData, roles: this.selectedRoles }
      this.$api
        .put(`/user/${userIdToEdit}`, payload)
        .then((response) => {
          const apiResponse = response.data

          this.setUserData(apiResponse.data)
          this.$notify({
            type: 'success',
            title: 'Succès',
            message: 'Utilisateur modifié avec succès !',
          })
        })
        .catch((error) => {
          if (error.response) {
            const apiResponse = error.response.data as ApiResponse

            this.$notify({
              type: 'error',
              title: 'Erreur',
              message:
                apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
            })
          }
        })
        .finally(() => {
          this.busy = false
          this.changeDetected = false
          loading.close()
        })
    },
  },
})
